import { type Component, defineAsyncComponent } from 'vue'

import type { BlockType } from '@backmarket/http-api/src/api-specs-content'

export const COMPONENT_FROM_CONTENT_TYPE: Record<BlockType, Component> = {
  AnimatedProductCheckpoints: defineAsyncComponent(
    () =>
      import(
        '../../blocks/AnimatedProductCheckpoints/AnimatedProductCheckpoints.vue'
      ),
  ),
  Button: defineAsyncComponent(
    () => import('@backmarket/nuxt-layer-cms/Button.vue'),
  ),
  Buttons: defineAsyncComponent(
    () => import('@backmarket/nuxt-layer-cms/Buttons.vue'),
  ),
  ArticleCardsList: defineAsyncComponent(
    () => import('@backmarket/nuxt-layer-cms/ArticleCardsList.vue'),
  ),
  // TODO COM-1345 Remove this component
  BuyingGuides: defineAsyncComponent(
    () => import('@backmarket/nuxt-layer-cms/ArticleCardsList.vue'),
  ),
  Carousel: defineAsyncComponent(
    () => import('../../blocks/Carousel/Carousel.vue'),
  ),
  Categories: defineAsyncComponent(
    () => import('../../blocks/Categories/Categories.vue'),
  ),
  Content: defineAsyncComponent(
    () => import('../../blocks/Content/Content.vue'),
  ),
  ContentMedia: defineAsyncComponent(
    () => import('../../blocks/ContentMedia/ContentMedia.vue'),
  ),
  Countdown: defineAsyncComponent(
    () => import('../../blocks/Countdown/Countdown.vue'),
  ),
  DiscountBanner: defineAsyncComponent(
    () => import('../../blocks/DiscountBanner/DiscountBanner.vue'),
  ),

  EmailCollector: defineAsyncComponent(
    () => import('@backmarket/nuxt-layer-cms/EmailCollector.vue'),
  ),
  EmbeddedYoutubeVideo: defineAsyncComponent(
    () => import('../../blocks/EmbeddedYoutubeVideo/EmbeddedYoutubeVideo.vue'),
  ),
  EnhancedCarousel: defineAsyncComponent(
    () => import('@backmarket/nuxt-layer-cms/EnhancedCarousel.vue'),
  ),
  Faq: defineAsyncComponent(() => import('../../blocks/Faq/Faq.vue')),
  HeroBanner: defineAsyncComponent(
    () => import('../../blocks/HeroBanner/HeroBanner.vue'),
  ),
  ListItem: defineAsyncComponent(
    () => import('../../blocks/ListItem/ListItem.vue'),
  ),
  Media: defineAsyncComponent(() => import('../../blocks/Media/Media.vue')),
  ModularCardsCarousel: defineAsyncComponent(
    () => import('../../blocks/ModularCard/ModularCardsCollection.vue'),
  ),
  ModularCardImage: defineAsyncComponent(
    () => import('../../blocks/ModularCard/ModularCardImage.vue'),
  ),
  PressCarousel: defineAsyncComponent(
    () => import('../../blocks/PressCarousel/PressCarousel.vue'),
  ),
  Products: defineAsyncComponent(
    () => import('@backmarket/nuxt-layer-cms/Products.vue'),
  ),
  Quiz: defineAsyncComponent(() => import('../../blocks/Quiz/Quiz.vue')),
  Recommendations: defineAsyncComponent(
    () => import('@backmarket/nuxt-layer-cms/Recommendations.vue'),
  ),
  RefinedProducts: defineAsyncComponent(
    () => import('@backmarket/nuxt-layer-cms/RefinedProducts.vue'),
  ),
  Reinsurance: defineAsyncComponent(
    () => import('@backmarket/nuxt-layer-cms/Reassurance.vue'),
  ),
  RelatedLinks: defineAsyncComponent(
    () => import('../../blocks/RelatedLinks/RelatedLinks.vue'),
  ),
  RichText: defineAsyncComponent(
    () => import('@backmarket/nuxt-layer-cms/RichText.vue'),
  ),
  SectionBanner: defineAsyncComponent(
    () => import('@backmarket/nuxt-layer-cms/SectionBanner.vue'),
  ),
  TrustpilotWidget: defineAsyncComponent(
    () => import('../../blocks/TrustpilotWidget/TrustpilotWidget.vue'),
  ),
  VideosBlock: defineAsyncComponent(
    () => import('@backmarket/nuxt-layer-cms/VideosBlock.vue'),
  ),
}
